export default __webpack_public_path__ + "static/compareItemImg3-551e94027abd163a5c4aed5d12f83d16.png";